var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ArtistNavbar',{attrs:{"currentPage":"Artists"}}),(_vm.event)?_c('ArtistPageMenu',{attrs:{"event":_vm.event,"currentPage":"MyAccount"}},[_c('h1',[_vm._v("My account")]),_c('ChangePassword')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }